import { roleAdmin, roleManager, roleSuperAdmin } from '@/mixins/roles';

const HotelsFlights = () => import('@/pages/hotels/flights.vue');

export default [
  {
    path: '/hotels/flights',
    name: 'HotelsFlights',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'SPA',
        'Flights',
      ],
    },
    component: HotelsFlights,
  },
  {
    path: '/hotels/flights/:id',
    name: 'HotelsFlightsForm',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'SPA',
        'Flights',
      ],
    },
    component: HotelsFlights,
  },
];
